module.exports = __webpack_public_path__ + "images/fifth_anniversary/step2-img_7f159db88d5279aec668afcf402e1a09.png";